import React, { ReactNode, useState } from "react";
import { Arrow } from "src/Components/ViewFragments/AboutUs/OptionsLabel";
import './styles.less'

type Props = {
    title:string
    content:ReactNode
};

const Accordion = (props: Props) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	return (
		<div
			className={`accordion ${isOpen ? "accordion--open" : ""}`}
			onClick={() => setIsOpen(state => !state)}>
			<div className="accordion__header">
				<h3 className={`accordion__header__title ${isOpen?'accordion__header__title--open':''}`} >{props.title}</h3>
				<Arrow className={`arrowDropdown ${isOpen ? "arrowDropdown--activeArrow" : ""}`} />
			</div>
			<div className={`accordion__content ${isOpen ? "accordion__content--open" : ""}`}>
				{props.content}
			</div>
		</div>
	);
};

export default Accordion;

